// ═══════════════════════════════════════════════════════════════
//  PARTNER LOGOS — the company names scrolling under the hero
//
//  TO ADD a partner:    add a new line like:   "Company Name",
//  TO REMOVE a partner: delete its line
//  Tip: 6–10 names looks best in the scrolling banner
// ═══════════════════════════════════════════════════════════════

export const partners = [
  "Dulux Trade",
  "Haymes Paint",
  "Porter's Paints",
  "Master Painters Australia",
  "Adelaide Heritage Trust",
  "Architecture SA",
  "MS BUIlD",
];
